import React from "react";

const CONFIDENCE_CONFIG = {
  exact: { label: 'Exacto', color: 'bg-emerald-100 text-emerald-800 border-emerald-300', icon: '✓' },
  very_high: { label: 'Muy Alto', color: 'bg-blue-100 text-blue-800 border-blue-300', icon: '◉' },
  high: { label: 'Alto', color: 'bg-sky-100 text-sky-800 border-sky-300', icon: '○' },
  medium: { label: 'Medio', color: 'bg-amber-100 text-amber-800 border-amber-300', icon: '◐' },
  low: { label: 'Bajo', color: 'bg-slate-100 text-slate-600 border-slate-300', icon: '◌' }
};

const MatchConfidenceBadge = ({ confidence, typeName }) => {
  if (!confidence) return null;
  
  const config = CONFIDENCE_CONFIG[confidence] || CONFIDENCE_CONFIG.low;
  
  return (
    <span 
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium border ${config.color}`}
      title={`Coincidencia ${config.label} con "${typeName}"`}
    >
      <span>{config.icon}</span>
      <span className="hidden sm:inline">{config.label}</span>
    </span>
  );
};

export default MatchConfidenceBadge;
